<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card>
      <v-card-title class="text-h5">
        Exception...
      </v-card-title>
      <v-card-text
        >Do you you want to make the quantity go to zero?</v-card-text
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="close">
          cancel
        </v-btn>
        <v-btn color="green darken-1" text @click="onSubmit">
          ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quantity: 0,
    };
  },

  methods: {
    onSubmit() {
      this.$emit("quantity", this.quantity);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
